import { LoadModel } from './load';

export class LoadPage {
  loads: LoadModel[];
  totalCount: number;
}
